import {
  BarChart3,
  CalendarClock,
  CalendarDays,
  ClipboardList,
  Coins,
  CreditCard,
  FileUp,
  Flag,
  HandCoins,
  Home,
  Landmark,
  LayoutGrid,
  PiggyBank,
  ReceiptText,
  Settings,
  ShoppingBag,
  Wallet,
  type LucideIcon,
} from "lucide-react";

export interface NavItem {
  to: string;
  label: string;
  icon: LucideIcon;
  description?: string;
}

export const TAB_ITEMS: NavItem[] = [
  { to: "/", label: "Inicio", icon: Home },
  { to: "/gastos", label: "Gastos", icon: ReceiptText },
  { to: "/tarjetas", label: "Tarjetas", icon: CreditCard },
  { to: "/mas", label: "Más", icon: LayoutGrid },
];

export const MORE_ITEMS: NavItem[] = [
  {
    to: "/plan",
    label: "Plan del periodo",
    icon: ClipboardList,
    description: "Lo que entra, lo que sale y cómo lo repartimos",
  },
  {
    to: "/cierre",
    label: "Cierre del periodo",
    icon: Flag,
    description: "Cómo fue el periodo pasado",
  },
  {
    to: "/presupuesto",
    label: "Presupuesto",
    icon: Wallet,
    description: "Fijos, variables e ingresos",
  },
  {
    to: "/pagos",
    label: "Pagos fijos",
    icon: CalendarClock,
    description: "Suscripciones, seguros y mensualidades",
  },
  {
    to: "/puedo-comprar",
    label: "¿Puedo comprarlo?",
    icon: ShoppingBag,
    description: "Revisa si te alcanza este periodo",
  },
  {
    to: "/calendario",
    label: "Calendario",
    icon: CalendarDays,
    description: "Cortes, pagos, ingresos y suscripciones",
  },
  {
    to: "/graficos",
    label: "Gráficos",
    icon: BarChart3,
    description: "Por categoría, por periodo y deuda",
  },
  {
    to: "/cuentas",
    label: "Débito y efectivo",
    icon: Landmark,
    description: "¿Cuánto dinero hay?",
  },
  { to: "/deudas", label: "Deudas", icon: HandCoins, description: "Préstamos y pagos a terceros" },
  {
    to: "/principal",
    label: "Principal",
    icon: Coins,
    description: "Lo que entra y a dónde se reparte",
  },
  { to: "/ahorro", label: "Ahorro", icon: PiggyBank, description: "Metas de ahorro e inversión" },
  {
    to: "/importar",
    label: "Importar estado de cuenta",
    icon: FileUp,
    description: "Lee tu PDF con IA y revisa",
  },
  { to: "/ajustes", label: "Ajustes", icon: Settings, description: "Cuentas, categorías y tema" },
];
